export default {
  featuresSection: {
    title: {
      fr: "Des fonctionnalités pour tous les usages.",
      en: "Smart features for every scenario.",
    },
    subtitle: {
      fr: "En quelques clics, Polynhome répond à tous vos besoins.",
      en: "In just a few clicks, Polynhome adapts to all your needs.",
    },
    features: {
      title: {
        fr: "Laissez parler votre imagination.",
        en: "Create smart scenarios tailored to your lifestyle.",
      },
      items: {
        energy: {
          title: {
            fr: "Ma consommation d'énergie",
            en: "Energy monitoring",
          },
          description: {
            fr: "Je fais des économies et je réduis mon empreinte énergétique.",
            en: "Save energy and reduce your environmental footprint.",
          },
        },

        heater: {
          title: {
            fr: "Éteindre le chauffage",
            en: "Smart heating control",
          },
          description: {
            fr: "Quand je pars, quand la fenêtre est ouverte.",
            en: "Automatically turn off heating when you leave or a window is open.",
          },
        },

        wallSwitch: {
          title: {
            fr: "Réagencer les interrupteurs",
            en: "Reconfigure switches",
          },
          description: {
            fr: "Au gré des nouveaux agencements, je reconfigure les interrupteurs depuis l'app.",
            en: "Adapt your switches to new layouts directly from the app.",
          },
        },

        accessControl: {
          title: {
            fr: "Ouvrir à distance",
            en: "Remote access",
          },
          description: {
            fr: "Le livreur est là.",
            en: "Open the door remotely when a delivery arrives.",
          },
        },

        ac: {
          title: {
            fr: "Climatiser au bon moment",
            en: "Smart cooling",
          },
          description: {
            fr: "J'arrive dans 20 minutes, c'est la canicule.",
            en: "Cool your home before you arrive on hot days.",
          },
        },

        light: {
          title: {
            fr: "Éclairer au bon moment",
            en: "Adaptive lighting",
          },
          description: {
            fr: "Il y a une présence et il fait sombre.",
            en: "Lights turn on automatically when presence is detected and it's dark.",
          },
        },

        shutters: {
          title: {
            fr: "Baisser les volets",
            en: "Automatic shutters",
          },
          description: {
            fr: "La nuit tombe.",
            en: "Shutters close automatically as night falls.",
          },
        },

        scenarios: {
          title: {
            fr: "Ambiance tamisée",
            en: "Cozy lighting",
          },
          description: {
            fr: "Tamiser les lumières du salon ou du bureau. Abaisser les volets.",
            en: "Create the perfect movie atmosphere with dimmed lights and closed shutters.",
          },
        },

        solarPanel: {
          title: {
            fr: "Exploiter mes panneaux solaires",
            en: "Solar energy optimization",
          },
          description: {
            fr: "Je produis de l'énergie, je charge mon véhicule.",
            en: "Use your solar production to power your home or charge your vehicle.",
          },
        },

        waterHeater: {
          title: {
            fr: "Déclencher le ballon d'eau chaude",
            en: "Smart water heating",
          },
          description: {
            fr: "Si mon panneau solaire produit au moins 2500 watt ou en heure creuse.",
            en: "Heat water automatically when solar production is high or during off-peak hours.",
          },
        },

        notification: {
          title: {
            fr: "Être alerté",
            en: "Smart notifications",
          },
          description: {
            fr: "Quelqu'un vient d'arriver.",
            en: "Receive instant alerts when someone arrives.",
          },
        },

        sprinkler: {
          title: {
            fr: "Déclencher l'arrosage",
            en: "Automated irrigation",
          },
          description: {
            fr: "À la fraîcheur de l'aube.",
            en: "Water your garden automatically in the cool of the early morning.",
          },
        },
      },
    },
  },
};
